 

import React from 'react';
import { Link } from 'react-router-dom';

const MobileBottomNav = ({ navigation, isCurrentPath }) => {
  return (
    <div className='mobile-tabbar-wrap fixed inset-x-0 bottom-0 z-30 px-3 lg:hidden'>
      <nav
        className='mobile-tabbar mx-auto flex w-full max-w-md items-center gap-1 rounded-[1.5rem] px-2 py-1.5'
        aria-label='Primary mobile navigation'
      >
        {navigation.map((item) => {
          const Icon = item.icon;
          const isActive = isCurrentPath(item.href);
          const navLabel = item.mobileLabel || item.label || item.name;

          return (
            <Link
              key={item.name}
              to={item.href}
              className='flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-2 py-1.5 text-center transition-all duration-200'
              style={{
                color: isActive ? 'var(--text-primary)' : 'var(--text-muted)',
                background: isActive ? 'var(--sidebar-active-bg)' : 'transparent',
              }}
              aria-current={isActive ? 'page' : undefined}
            >
              <span
                className='flex h-9 w-9 items-center justify-center rounded-xl transition-all duration-200'
                style={{
                  background: isActive ? 'rgba(45, 212, 191, 0.18)' : 'transparent',
                  color: isActive ? 'var(--brand-dark)' : 'var(--text-muted)',
                }}
              >
                <Icon className='h-[1.05rem] w-[1.05rem]' />
              </span>
              <span
                className='truncate text-[0.64rem] font-semibold tracking-[0.01em]'
                style={{ color: isActive ? 'var(--text-primary)' : 'var(--text-muted)' }}
              >
                {navLabel}
              </span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default MobileBottomNav;
